module.exports = __webpack_public_path__ + "static/media/img77.7c42bbc3.jpg";